import { URL_GET_LANGUAGE_TYPES } from 'constants/urls';

/**
 * @async
 * @function getLanguagesApi
 * @returns {Promise<LanguageType>}
 * @throws {Error}
 */
async function getLanguagesApi() {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_LANGUAGE_TYPES, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
}

export default getLanguagesApi;
